import { LOCATION_WINTER } from 'app/constants/AppConstants';

export default class ClothDragged extends Phaser.Image {
  constructor(game, x, y, clothData, slotRef) {
    super(game, x, y);

    this.clothData = clothData;
    this.slotRef = slotRef;

    // fix for Olive in winter
    let key = this.clothData.image_key;
    if (this.game.controller.location === LOCATION_WINTER && key.indexOf('olive') > -1) {
      key += '_winter';
    }

    this.loadTexture('ui_dress_up', key);
    this.anchor.set(0.5);

    // interactions
    this.inputEnabled = true;
    this.input.enabled = true;
    this.game.input.onUp.add(this.onReleaseMe, this);
  }

  startDrag(pointer) {
    this.pointer = pointer;
    this.isDragging = true;
    this.dx = this.x + this.parent.x - pointer.x;
    this.dy = this.y + this.parent.y - pointer.y;
  }

  onDragMe(sprite, pointer, dragX, dragY, snapPoint) {
    sprite;
    pointer;
    dragX;
    dragY;
    snapPoint;
  }

  onReleaseMe(pointer) {
    if (this.pointer !== pointer) {
      return;
    }

    //
    this.input.enabled = false;
    this.input.disableDrag();

    //
    this.events.onDragUpdate.remove(this.onDragMe, this);
    this.game.input.onUp.remove(this.onReleaseMe, this);

    //
    this.game.state.getCurrentState().stopDragCloth(this);

    //
    this.destroy();
  }

  update() {
    if (this.isDragging) {
      const pointer = this.pointer; // this.game.input.position;
      this.x = pointer.x + this.dx - this.parent.x;
      this.y = pointer.y + this.dy - this.parent.y;
    }

    super.update();
  }
}
